import "./chunk-IKVHEMWL.mjs";
import {
  ErrorsList
} from "./chunk-OBDKXFRU.mjs";
import "./chunk-CEK6WBHQ.mjs";
import "./chunk-GQ7SPVGC.mjs";
import {
  FilesList
} from "./chunk-VPRU2JEC.mjs";
import "./chunk-OOLLVNBU.mjs";
import "./chunk-PJOL3MPD.mjs";
import "./chunk-UWNWOSVP.mjs";
import "./chunk-YOUQFJNO.mjs";
import {
  Dropzone
} from "./chunk-GOQEJSF4.mjs";
import "./chunk-3V3EYMEX.mjs";
import "./chunk-VHDOGGRV.mjs";
import "./chunk-FSGMVFUH.mjs";
import "./chunk-DTOUNUTO.mjs";
import "./chunk-KHJY7Z5R.mjs";

// src/index.tsx
import { Flex } from "@chakra-ui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var DocumentsUploader = ({
  dropText,
  selectText,
  supportedFilesText,
  uploadText,
  isLoading,
  loadingText,
  onDelete,
  acceptedFiles,
  fileRejections,
  isDropzoneActive,
  getInputProps,
  getRootProps,
  getErrorMessage,
  isInvalid,
  dataTestId
}) => {
  const showUploaderGap = (acceptedFiles == null ? void 0 : acceptedFiles.length) > 0 || (fileRejections == null ? void 0 : fileRejections.length) > 0;
  const showFilesGap = (acceptedFiles == null ? void 0 : acceptedFiles.length) > 0 && (fileRejections == null ? void 0 : fileRejections.length) > 0;
  return /* @__PURE__ */ jsxs(Flex, {
    direction: "column",
    justify: "center",
    align: "center",
    gap: showUploaderGap ? 4 : 0,
    children: [
      /* @__PURE__ */ jsx(Dropzone, {
        isLoading,
        uploadText,
        selectText,
        supportedFilesText,
        loadingText,
        dropText,
        isDropzoneActive,
        getInputProps,
        getRootProps,
        fileRejections,
        isInvalid,
        dataTestId
      }),
      /* @__PURE__ */ jsxs(Flex, {
        direction: "column",
        justify: "center",
        align: "center",
        w: "100%",
        gap: showFilesGap ? 4 : 0,
        children: [
          /* @__PURE__ */ jsx(Flex, {
            direction: "column",
            justify: "center",
            align: "center",
            w: "100%",
            gap: 4,
            children: fileRejections && /* @__PURE__ */ jsx(ErrorsList, {
              fileRejections,
              getErrorMessage
            })
          }),
          acceptedFiles && /* @__PURE__ */ jsx(FilesList, {
            files: acceptedFiles,
            onDelete
          })
        ]
      })
    ]
  });
};
export {
  DocumentsUploader
};
